import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../../shared/Navbar/Navbar";
import Footer from "../../../shared/Footer/Footer";
import ProjectDetailsBanner from "./ProjectDetailsBanner";
import DetailProject from "./DetailProject";
import { workProjects } from "../../../../data/workProjects";
import OurWorkAdd from "./OurWorkAdd";
import HaveAProject from "../../Insights/HaveAProject/HaveAProject";
import { useCmsPageSection } from "../../../../hooks/useCmsPageSection";
import { getWorkProjectsFromSection } from "../../../../services/contentApi";

const ProjectDetails = () => {
  const { slug } = useParams();
  const { section, loading } = useCmsPageSection("work", "work-projects");

  const projects = useMemo(() => {
    if (section?.fields) {
      return getWorkProjectsFromSection(section);
    }
    return workProjects.map((p) => ({
      ...p,
      image: p.image,
      services: p.services ?? [],
      tech: [],
      featured: true,
    }));
  }, [section]);

  const project = projects.find((item) => item.slug === slug) ?? projects[0];

  if (loading && !project) return null;

  return (
    <div>
      <Navbar />
      <ProjectDetailsBanner project={project} />
      <DetailProject project={project} />
      <OurWorkAdd />
      <HaveAProject />
      <Footer />
    </div>
  );
};

export default ProjectDetails;
